export const FlatTableCellName = {
  Area: 'area',
  Building: 'building',
  BuildingGroups: 'building_groups',
  Category: 'category',
  Condition: 'condition',
  ContractType: 'contract_type',
  Created: 'created',
  Dwellers: 'dwellers',
  Entrance: 'entrance',
  EntranceAddress: 'entrance_address',
  Equipment: 'equipment',
  FlatSpecifics: 'flat_specifics',
  Floor: 'floor',
  HeatType: 'heat_type',
  Landlords: 'landlords',
  LiveArea: 'live_area',
  Number: 'number',
  ORAGCoolingType: 'orag_cooling_type',
  ORAGEdvNumber: 'orag_edv_number',
  ORAGFlatEquipment: 'orag_flat_equipment',
  ORAGFunding: 'orag_funding',
  ORAGKeys: 'orag_keys',
  ORAGMeterReading: 'orag_meter_reading',
  ORAGReasonTermination: 'orag_reason_termination',
  ORAGReasonVacancy: 'orag_reason_vacancy',
  ORAGUnitNumber: 'orag_unit_number',
  PropertyShare: 'property_share',
  RentPaymentType: 'rent_payment_type',
  RoomCount: 'room_count',
  RoomType: 'room_type',
  UnitNumber: 'unit_number',
  Updated: 'updated',
}
